<script setup lang="ts">
defineOptions({ inheritAttrs: false })
</script>

<template>
  <transition
    enter-active-class="transform transition ease-in-out duration-300"
    enter-from-class="scale-75 opacity-0"
    enter-to-class="scale-100 opacity-100"
    leave-active-class="transform transition ease-in-out duration-300"
    leave-from-class="scale-100 opacity-100"
    leave-to-class="scale-75 opacity-0"
    v-bind="$attrs"
  >
    <slot></slot>
  </transition>
</template>
